<input class="mvd_form-control" [ngModel]="displayValue" (ngModelChange)="displayValueChanged($event)" [disabled]="disabled"/>
<ng-container *ngIf="hasErrors()">
    <alert *ngFor="let error of errors" type="danger">
        {{error}}
    </alert>
</ng-container>

<div class="autocomplete__dropdown" [ngClass]="{hidden: !resultsModel}">
    <ul class="list--bulletless--content">
        <li *ngFor="let result of resultsModel" value="{{result[value]}}" (click)="autocompleteSelected(result)">{{getResultText(result)}}</li>
    </ul>
</div>
